export default __webpack_public_path__ + "static/logo-4-44b7fce632f8c6e50e4b0ead11b49da0.webp";